<template>
  <div class="store_finder_banner_content">
    <h1 class="main_heading" v-html="sanitizeHtml(shopifyData.title)" />
    <div class="stre_finder_banner_container">
      <div class="store_finder_banner_text">
        <p class="body_text" v-html="sanitizeHtml(shopifyData.info)" />
        <div class="store_list">
          <div
            v-for="store in shopifyData.storeInfo"
            :key="store.country"
            class="store_item"
            :class="store.countryClass ? store.countryClass : ''"
          >
            <h3>{{ store.country }}</h3>
            <div v-html="formatAddress(store.storeName)" />
          </div>
        </div>
      </div>
      <div class="store_finder_banner_image">
        <picture>
          <source
            v-lazy="shopifyData.mobImg"
            media="(max-width: 768px)"
            :srcset-placeholder="shopifyData.mobImg.placeHolder"
          />
          <img
            v-lazy="shopifyData.desktopImg"
            :src-placeholder="shopifyData.desktopImg.placeHolder"
            :alt="shopifyData.desktopImg.alt"
            class="heroImg"
          />
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const image = this.$el.querySelector('.store_finder_banner_image .heroImg');
      const storeList = this.$el.querySelector('.store_list');
      if (image && storeList) {
        if (window.innerWidth > 768) {
          storeList.style.maxHeight = image.offsetHeight + 'px';
        }
      }
    });
  },
  methods: {
    sanitizeHtml,
    formatAddress(address) {
      if (!address) return '';
      const formatted = address.replace(/,\s*/g, '<br>');
      return sanitizeHtml(formatted);
    },
  },
};
</script>

<style scoped>
.stre_finder_banner_container {
  display: flex;
  gap: 73px;
}

.store_finder_banner_text {
  max-width: 50%;
  width: 100%;
  padding-left: 68px;
}

.main_heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 100%;
  text-align: center;
  margin-bottom: 55px;
  padding: 21px 0;
}

.body_text {
  font-family: 'Helvetica Neue', sans-serif;

  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: 74px;
}

.store_finder_banner_image {
  max-width: 50%;
  width: 100%;
}

.heroImg {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.store_list {
  max-height: 100vh;
  scroll-behavior: smooth;
  overflow-y: auto;
  transition: 0.2s;
  scrollbar-width: none;
  scrollbar-color: #d2d1d1 #ffffff;
}

/* .store_list::-webkit-scrollbar {
    display: none;  
} */
.store_list:hover {
  overflow-y: auto;
  scrollbar-width: thin;
}

/* Chrome, Edge, and Safari */
.store_list::-webkit-scrollbar {
  width: 5px;
}

.store_list::-webkit-scrollbar-track {
  background: #ffffff;
}

.store_list::-webkit-scrollbar-thumb {
  background-color: #d2d1d1;
  border-radius: 10px;
  border: 3px none #ffffff;
}

.store_list h3 {
  font-family: 'Helvetica Neue', sans-serif;

  font-weight: 700;
  font-size: 15px;
  line-height: 27px;
  letter-spacing: 0%;
  vertical-align: middle;
}

.store_list div {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 17px;
  display: block;
  /* line-height: 24px; */
}

.store_item {
  position: relative;
}

.store_item:not(:last-child) {
  margin-bottom: 33px;
}

.store_item.country:not(:first-child) {
  margin-top: 66px;
}

.store_item.country:not(:first-child)::after {
  content: '';
  position: absolute;
  left: 0;
  top: -33px;
  height: 1px;
  width: 25px;
  background-color: #000;
}

@media (max-width: 991px) {
  .store_finder_banner_text {
    padding-left: 20px;
  }

  .stre_finder_banner_container {
    gap: 20px;
  }

  .body_text {
    margin-bottom: 53px;
  }
}

@media (max-width: 768px) {
  .stre_finder_banner_container {
    display: flex;
    gap: 23px;
    flex-direction: column-reverse;
  }

  .store_finder_banner_image {
    max-width: 100%;
    width: 100%;
  }

  .store_finder_banner_text {
    max-width: 100%;
    width: 100%;
    padding: 0 20px;
  }

  .store_list {
    max-height: 100%;
    overflow-y: unset;
  }

  .main_heading {
    margin-bottom: 18px;
    font-size: 10px;
  }
}
</style>
